import { Grid, TextField } from '@material-ui/core';
import { Lambda } from '../../LambdaListEditor';

interface LambdaBasicFieldsProps {
  lambda: Lambda;
  onUpdate: (field: keyof Lambda, value: string) => void;
  showInGrid?: boolean;
  showBuildNumber?: boolean;
}

export const LambdaBasicFields = ({
  lambda,
  onUpdate,
  showInGrid = true,
  showBuildNumber = true,
}: LambdaBasicFieldsProps) => {
  const handlerField = (
    <TextField
      label="Lambda Handler"
      value={lambda.lambda_handler || ''}
      onChange={e => onUpdate('lambda_handler', e.target.value)}
      fullWidth
      variant="outlined"
      size="small"
      placeholder="e.g., com.lexipol.example.Handler::handleRequest"
    />
  );

  const sourceField = (
    <TextField
      label="Lambda Source"
      value={lambda.lambda_source || ''}
      onChange={e => onUpdate('lambda_source', e.target.value)}
      fullWidth
      variant="outlined"
      size="small"
      placeholder="e.g., solutions-api-lambdas"
    />
  );

  const buildNumberField = (
    <TextField
      label="Build Number (optional)"
      value={lambda.build_number || ''}
      onChange={e => onUpdate('build_number', e.target.value)}
      fullWidth
      variant="outlined"
      size="small"
    />
  );

  if (showInGrid) {
    return (
      <>
        <Grid item xs={12}>
          {handlerField}
        </Grid>
        <Grid item xs={12} md={6}>
          {sourceField}
        </Grid>
        <Grid item xs={12} md={6}>
          {showBuildNumber ? buildNumberField : null}
        </Grid>
      </>
    );
  }

  return (
    <>
      {handlerField}
      {sourceField}
      {showBuildNumber ? buildNumberField : null}
    </>
  );
};
